export enum ReconfigureAgentEndpointMethod {
  GET_FEATURES_BY_COMPANY_IDS = 'getFeaturesByCompanyIds',
}
